import { render, staticRenderFns } from "./ContactsFlowView.vue?vue&type=template&id=679eddd7&scoped=true&"
import script from "./ContactsFlowView.vue?vue&type=script&lang=js&"
export * from "./ContactsFlowView.vue?vue&type=script&lang=js&"
import style0 from "./ContactsFlowView.vue?vue&type=style&index=0&id=679eddd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679eddd7",
  null
  
)

export default component.exports